import { Component, Input, OnInit } from '@angular/core';
import { DocumentService } from '../../api';

@Component({
  selector: 'school-header-ui',
  templateUrl: './header-ui.component.html',
  styleUrls: ['./header-ui.component.scss']
})
export class HeaderuiComponent implements OnInit {

  @Input() title: any;
  @Input() organisation_name: any;
  @Input() organisation_address: any;
  @Input() organisation_logo: any;
  @Input() reg_no: any;

  screenWidth: number;

  constructor() { }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
    };
  }

}
